const localState = {
    monthRequests: null,
    monthMetrics: null,
    currentMetrics: null,
    dayMetrics: null,
    view: null,
    dayKey: null,
}

const mutations = {
    setState: (state, {
        key,
        value,
    }) => {
        state[key] = value
    },
    setMonthRequest: (state, v) => {
        state.monthRequests = v
    },
    setDayMetrics: (state) => {
        if (state.dayKey === null) return

        if (state.monthRequests[state.dayKey]) {
            state.dayMetrics = state.monthRequests[state.dayKey].metrics
        }
    },
}

const actions = {}

const getters = {
    currentMetrics: (state) => (state.view === 'month' ? state.monthMetrics : state.dayMetrics),
    lastMetrics: (state) => state.lastMetrics,
    view: (state) => state.view,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
